import * as React from "react"

const SvgRecommendationReciprocated = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.954 4.26q3.198-.839 6.1.836.518.3.995.676.475.376.874.836.304.321.252.738a.9.9 0 0 1-.426.663q-.36.225-.76.167a1.2 1.2 0 0 1-.706-.378 4 4 0 0 0-.573-.533 6 6 0 0 0-.657-.437q-2.187-1.261-4.588-.628-2.4.634-3.651 2.8l-.088.151 1.23-.33a.95.95 0 0 1 .743.112.95.95 0 0 1 .47.589q.1.375-.113.743a.95.95 0 0 1-.588.469l-3.552.952a.96.96 0 0 1-.756-.09.96.96 0 0 1-.456-.61l-.952-3.552a.95.95 0 0 1 .112-.744.95.95 0 0 1 .588-.468.95.95 0 0 1 .744.111.95.95 0 0 1 .469.589l.33 1.229.087-.152q1.674-2.9 4.872-3.74M8.954 17.17q-.346-.2-.656-.437a4 4 0 0 1-.573-.532 1.23 1.23 0 0 0-.715-.385 1.1 1.1 0 0 0-.771.161.85.85 0 0 0-.413.642.86.86 0 0 0 .23.725q.42.473.889.86.47.386 1.01.699 2.899 1.674 6.094.836 3.195-.839 4.869-3.74l.087-.151.329 1.23q.1.375.468.587a.95.95 0 0 0 .744.112.95.95 0 0 0 .587-.469.95.95 0 0 0 .112-.743l-.951-3.552a.96.96 0 0 0-.456-.61.96.96 0 0 0-.755-.09l-3.55.952a.95.95 0 0 0-.587.469.95.95 0 0 0-.112.743q.1.376.469.588a.95.95 0 0 0 .743.112l1.228-.33-.087.152q-1.25 2.166-3.649 2.8t-4.584-.628" />
  </svg>
)
export default SvgRecommendationReciprocated
